module.exports = __webpack_public_path__ + "static/icons/icon-ski-pass-9e7e5f2f3c601165bb9ae145ddb40acc.svg";